/**
 * Helper to determine if a URL points to a video file.
 */
export function isVideo(url: string | null | undefined): boolean {
	if (!url) return false;
	if (url.startsWith('data:video/')) return true;
	const extension = url.split('.').pop()?.split('?')[0]?.toLowerCase();
	return ['mp4', 'webm', 'ogg', 'mov'].includes(extension || '');
}
